import React from 'react'
import styled from 'styled-components'

import { Brand } from 'components'

const Root = styled.div`
  position: sticky;
  top: 0;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0rem 1.5rem;
  flex-direction: row;
  background-color: ${({ theme }) => theme.colors.surface};
  ${'' /* border-bottom: 1px solid ${({ theme }) => theme.colors.border}; */}
  box-shadow: 0px 4px 24px -8px rgba(0, 0, 0, 0.08);
  z-index: 10;
`

export const Header = () => {
  return (
    <Root>
      <Brand size={1} />
    </Root>
  )
}
